import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import {
    BTConfirm,
    BTConfirmContent,
    BTConfirmFooter,
} from "commonComponents/btWrappers/BTConfirm/BTConfirm";

import { type BillListFormActions } from "../BillList.api.types";

interface IMassUpdateAccountingStatusProps {
    actionBeingPerformed: BillListFormActions;
    accountingIntegrationName: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export const MassUpdateAccountingStatus: React.FunctionComponent<
    IMassUpdateAccountingStatusProps
> = ({ actionBeingPerformed, accountingIntegrationName, onCancel, onConfirm }) => (
    <BTConfirm visible title="Update status on selected bills?">
        <BTConfirmContent>
            This will update the {accountingIntegrationName} status on the selected bills and may
            take a moment to process.
        </BTConfirmContent>
        <BTConfirmFooter>
            <BTButton<BillListFormActions>
                actionBeingPerformed={actionBeingPerformed}
                loadingAction="cancel"
                type="secondary"
                data-testid="cancelUpdateAccountingStatus"
                onClick={onCancel}
                className="margin-right-xs"
            >
                Cancel
            </BTButton>
            <BTButton<BillListFormActions>
                actionBeingPerformed={actionBeingPerformed}
                loadingAction="checkedAction"
                data-testid="confirmUpdateAccountingStatus"
                onClick={onConfirm}
                type="primary"
            >
                Update
            </BTButton>
        </BTConfirmFooter>
    </BTConfirm>
);
